<div class="rebook-modal">
    <div class="rebook-modal__header">
        <div class="header-copy">
            <h2>Reservierung umbuchen</h2>
            <p>
                Umbuchung für
                <strong>{{ data.reservation.guestName }}</strong>
                ({{ data.reservation.persons }} Pers., Tisch {{ data.reservation.table }})
            </p>
            <p>
                Zieltyp:
                <strong>{{ placeTypeLabel }}</strong>
            </p>
        </div>

        <button type="button" class="close-button" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="form-group">
        <label>Neue Show</label>

        <div class="dropdown-wrapper">
            <button type="button" class="select-button" [class.select-button--active]="isShowDropdownOpen"
                (click)="toggleShowDropdown($event)">
                <span>{{ selectedShow?.label ?? 'Show wählen' }}</span>
                <mat-icon>{{ isShowDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            <div class="custom-dropdown-panel custom-dropdown-panel--large" *ngIf="isShowDropdownOpen"
                (click)="$event.stopPropagation()">
                <button type="button" class="custom-dropdown-option" *ngFor="let option of data.showOptions"
                    [class.custom-dropdown-option--selected]="selectedShowValue === option.value"
                    (click)="selectShow(option)">
                    <span>{{ option.label }}</span>
                </button>
            </div>
        </div>
    </div>

    <div class="form-group" *ngIf="selectedShow">
        <label>Neuer Zeitblock</label>

        <div class="dropdown-wrapper">
            <button type="button" class="select-button" [class.select-button--active]="isBlockDropdownOpen"
                (click)="toggleBlockDropdown($event)">
                <span>{{ selectedBlock?.label ?? 'Zeitblock wählen' }}</span>
                <mat-icon>{{ isBlockDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            <div class="custom-dropdown-panel" *ngIf="isBlockDropdownOpen" (click)="$event.stopPropagation()">
                <button type="button" class="custom-dropdown-option" *ngFor="let option of selectedShow.blocks"
                    [class.custom-dropdown-option--selected]="selectedBlockValue === option.value"
                    (click)="selectBlock(option)">
                    <span>{{ option.label }}</span>
                </button>
            </div>
        </div>
    </div>

    <div class="form-group" *ngIf="selectedBlock">
        <label>Bereich</label>

        <div class="dropdown-wrapper">
            <button type="button" class="select-button" [class.select-button--active]="isAreaDropdownOpen"
                (click)="toggleAreaDropdown($event)">
                <span>{{ selectedArea?.areaName ?? 'Bereich wählen' }}</span>
                <mat-icon>{{ isAreaDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            <div class="custom-dropdown-panel" *ngIf="isAreaDropdownOpen" (click)="$event.stopPropagation()">
                <button type="button" class="custom-dropdown-option" *ngFor="let option of availableAreas"
                    [class.custom-dropdown-option--selected]="selectedAreaId === option.areaId"
                    (click)="selectArea(option)">
                    <span>{{ option.areaName }}</span>
                </button>
            </div>
        </div>
    </div>

    <div class="form-group" *ngIf="selectedArea">
        <label>Tisch</label>

        <div class="dropdown-wrapper">
            <button type="button" class="select-button" [class.select-button--active]="isTableDropdownOpen"
                (click)="toggleTableDropdown($event)">
                <span>
                    {{
                    selectedTable
                    ? ('T' + selectedTable.tableNumber + ' – ' + getTableFreePlaces(selectedTable) + '/' +
                    getTableTotalPlaces(selectedTable) + ' frei')
                    : 'Tisch wählen'
                    }}
                </span>
                <mat-icon>{{ isTableDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            <div class="custom-dropdown-panel" *ngIf="isTableDropdownOpen" (click)="$event.stopPropagation()">
                <button type="button" class="custom-dropdown-option" *ngFor="let option of availableTables"
                    [class.custom-dropdown-option--selected]="selectedTableNumber === option.tableNumber"
                    (click)="selectTable(option)">
                    <span>
                        T{{ option.tableNumber }} – {{ getTableFreePlaces(option) }}/{{ getTableTotalPlaces(option) }}
                        frei
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="modal-actions">
        <button type="button" class="secondary-button" (click)="close()">
            Abbrechen
        </button>

        <button type="button" class="primary-button" [disabled]="!canSubmit" (click)="submit()">
            Umbuchen
        </button>
    </div>
</div>